import script from "./KPISection.vue?vue&type=script&setup=true&lang=js"
export * from "./KPISection.vue?vue&type=script&setup=true&lang=js"

import "./KPISection.vue?vue&type=style&index=0&id=1e201a60&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e201a60"]])

export default __exports__